import type { PermissionData } from '../types'

export function computeRouteDetailsPermission(permissionData: PermissionData) {
  if (permissionData.routesCount !== 1) return 'hidden'
  if (permissionData.isSimulation || !permissionData.allRoutesApproved) return 'hidden'

  return 'enabled'
}
